
import Vue from "vue";
import { DashboardItem } from "@/utils/dashboard/dashboard-item";
import AppTinyInfo from "./TinyInfo.vue";
import {ChartService} from "@/services";
import { DashboardPurchaseChartData } from "@/utils/dashboard/dashboard-purchase-chart-data";

export default Vue.extend({
	data(){
		return {
			totalOpen: 0.0
		};
	},
	props: {
		item: {
			type: Object as ()=>DashboardItem,
			required: true
		}
	},
	computed: {
		chartData():DashboardPurchaseChartData{
			return this.item.Data as DashboardPurchaseChartData;
		}
	},
	methods: {
		async fetch(){
			this.totalOpen = await ChartService.getTotalOpenPurchase(this.chartData.filters, this.chartData.getBookYearOverrideValue());
		}
	},
	created(){
		this.fetch();
	},
	components: {
		AppTinyInfo
	},
	i18nEx: {
		componentPrefix: "views.HomeRoute"
	}
});
